// extracted by mini-css-extract-plugin
export var activeItem = "TreatmentSection-module--activeItem--aca5f";
export var contentColor = "TreatmentSection-module--contentColor--2e938";
export var headerStyling = "TreatmentSection-module--headerStyling--e4530";
export var itemStyling = "TreatmentSection-module--itemStyling--de63a";
export var sectionBackGround = "TreatmentSection-module--sectionBackGround--26409";
export var treatmentsCardsContainer = "TreatmentSection-module--treatmentsCardsContainer--382d1";
export var treatmentsContainer = "TreatmentSection-module--treatmentsContainer--47248";
export var treatmentsContent = "TreatmentSection-module--treatmentsContent--f9149";
export var treatmentsNav = "TreatmentSection-module--treatmentsNav--cbf52";
export var treatmentsNavItem = "TreatmentSection-module--treatmentsNavItem--ffa3b";